import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';
import { DevExSelectBoxComponent } from '../../../devExtreme/src/devExSelectBox/devExSelectBox.component';
import { ComponentStyle, IAbcComponent, StylingMode } from '../abcComponent.model';
import { AbcComponentService } from '../abcComponent.service';
import { ISelectBox, SelectBoxSearchMode, ValidationStatus } from './abcSelectBox';
@Component({
    selector: 'abcSelectBox',
    template: '<ng-template #abcSelectBox></ng-template>',
    standalone: false
})
export class AbcSelectBoxComponent implements IAbcComponent, OnInit {
  @ViewChild('abcSelectBox', { static: true, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  public selectBoxAttributes: ISelectBox;
  @Input() valueExpr: string;
  @Input() readOnly: boolean;
  @Input() displayExpr: string;
  @Input() specificTemplate: boolean;
  @Output() onValueChanged = new EventEmitter();
  @Output() onSelectedItem = new EventEmitter();
  @Output() onCustomItemCreating = new EventEmitter();
  public componentRef;
  private devExSelectBox: DevExSelectBoxComponent;
  private eventListener = [];
  private _disabled: boolean;

  private _items: string[];

  private _dataSource: any[] | null;

  private _value: any;
  private _placeholder: string;
  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(data) {
    if (this.componentRef) {
      this.componentRef.placeholder = data;
    }
    this._placeholder = data;
  }

  @Input() id: string;
  @Input()
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(val: boolean) {
    this._disabled = val;
    if (this.componentRef) {
      this.componentRef.disabled = val;
    }
  }

  @Input()
  get items(): string[] {
    return this._items;
  }
  set items(val: string[]) {
    this._items = val;
    if (this.componentRef) {
      this.componentRef.items = val;
    }
  }

  @Input()
  get dataSource(): any[] | null {
    return this._dataSource;
  }
  set dataSource(val: any[] | null) {
    this._dataSource = val;
    if (this.componentRef) {
      this.componentRef.dataSource = val;
    }
  }

  @Input()
  get value(): any {
    return this._value;
  }
  set value(val: any) {
    this._value = val;
    if (this.componentRef) {
      this.componentRef.value = val;
    }
  }

  @Output() valueChange = new EventEmitter();

  private _hoverStateEnabled: boolean;
  @Input()
  get hoverStateEnabled(): boolean {
    return this._hoverStateEnabled;
  }
  set hoverStateEnabled(val: boolean) {
    this._hoverStateEnabled = val;
    if (this.componentRef) {
      this.componentRef.hoverStateEnabled = val;
    }
  }

  private _height: string;
  @Input()
  get height(): string {
    return this._height;
  }
  set height(val: string) {
    this._height = val;
    if (this.componentRef) {
      this.componentRef.height = val;
    }
  }

  private _width: string;
  @Input()
  get width(): string {
    return this._width;
  }
  set width(val: string) {
    this._width = val;
    if (this.componentRef) {
      this.componentRef.width = val;
    }
  }

  private _visible: boolean = true;
  @Input()
  get visible(): boolean {
    return this._visible;
  }
  set visible(val: boolean) {
    this._visible = val;
    if (this.componentRef) {
      this.componentRef.visible = val;
    }
  }

  private _showDropDownButton: boolean;
  @Input()
  get showDropDownButton(): boolean {
    return this._showDropDownButton;
  }
  set showDropDownButton(val: boolean) {
    this._showDropDownButton = val;
    if (this.componentRef) {
      this.componentRef.showDropDownButton = val;
    }
  }

  private _showSelectionControls: boolean;
  @Input()
  get showSelectionControls(): boolean {
    return this._showSelectionControls;
  }
  set showSelectionControls(val: boolean) {
    this._showSelectionControls = val;
    if (this.componentRef) {
      this.componentRef.showSelectionControls = val;
    }
  }

  private _showClearButton: boolean;
  @Input()
  get showClearButton(): boolean {
    return this._showClearButton;
  }
  set showClearButton(val: boolean) {
    this._showClearButton = val;
    if (this.componentRef) {
      this.componentRef.showClearButton = val;
    }
  }

  private _acceptCustomValue: boolean;
  @Input()
  get acceptCustomValue(): boolean {
    return this._acceptCustomValue;
  }
  set acceptCustomValue(val: boolean) {
    this._acceptCustomValue = val;
    if (this.componentRef) {
      this.componentRef.acceptCustomValue = val;
    }
  }

  private _rtlEnabled: boolean;
  @Input()
  get rtlEnabled(): boolean {
    return this._rtlEnabled;
  }
  set rtlEnabled(val: boolean) {
    this._rtlEnabled = val;
    if (this.componentRef) {
      this.componentRef.rtlEnabled = val;
    }
  }

  private _searchEnabled: boolean;
  @Input()
  get searchEnabled(): boolean {
    return this._searchEnabled;
  }
  set searchEnabled(val: boolean) {
    this._searchEnabled = val;
    if (this.componentRef) {
      this.componentRef.searchEnabled = val;
    }
  }

  private _stylingMode: StylingMode;
  @Input()
  get stylingMode(): StylingMode {
    return this._stylingMode;
  }
  set stylingMode(val: StylingMode) {
    this._stylingMode = val;
    if (this.componentRef) {
      this.componentRef.stylingMode = val;
    }
  }

  private _validationStatus: ValidationStatus = ValidationStatus.Valid;
  @Input()
  get validationStatus(): ValidationStatus {
    return this._validationStatus;
  }
  set validationStatus(val: ValidationStatus) {
    this._validationStatus = val;
    if (this.componentRef) {
      this.componentRef.validationStatus = val;
    }
  }

  private _class: string;
  @Input()
  get class(): string {
    return this._class;
  }
  set class(val: string) {
    this._class = val;

    if (this.componentRef) {
      this.componentRef.class = val;
    }
  }

  private _style: ComponentStyle;
  @Input()
  get style(): ComponentStyle {
    return this._style;
  }
  set style(val: ComponentStyle) {
    this._style = val;
    if (this.componentRef) {
      this.componentRef.style = val;
    }
  }

  private _searchMode: SelectBoxSearchMode = SelectBoxSearchMode.Contains;
  @Input()
  get searchMode(): SelectBoxSearchMode {
    return this._searchMode;
  }
  set searchMode(val: SelectBoxSearchMode) {
    this._searchMode = val;
    if (this.componentRef) {
      this.componentRef.searchMode = val;
    }
  }

  private _searchExpr: string[];
  @Input()
  get searchExpr(): string[] {
    return this._searchExpr;
  }
  set searchExpr(val: string[]) {
    this._searchExpr = val;
    if (this.componentRef) {
      this.componentRef.searchExpr = val;
    }
  }

  private _searchTimeout: number;
  @Input()
  get searchTimeout(): number {
    return this._searchTimeout;
  }
  set searchTimeout(val: number) {
    this._searchTimeout = val;
    if (this.componentRef) {
      this.componentRef.searchTimeout = val;
    }
  }

  constructor(private abcComponentService: AbcComponentService) {
    this.style = ComponentStyle.DevExpress;
    this.rtlEnabled = this.abcComponentService.rtlEnabled;
  }

  ngOnInit() {
    this.setSelectBoxAttributesIfAvailable();
    this.createComponentInstance().subscribe((component) => {
      this.eventListener.forEach((element) => {
        component.addEventListener(element.type, element.listener);
      });
    });
  }

  ngAfterViewInit() {
    this.abcComponentService.addInstance(this);
  }

  ngOnDestroy(): void {
    this.eventListener = [];
    this.abcComponentService.removeInstance(this);
  }

  createComponentInstance(): Observable<any> {
    const observable = new Observable((observer) => {
      switch (this.style) {
        case ComponentStyle.Material: {
          break;
        }
        case ComponentStyle.DevExpress: {
          this.componentRef = this.abcComponentService.loadComponent(
            DevExSelectBoxComponent,
            this.viewContainerRef
          ).componentRef.instance;
          this.componentRef.id = this.id;
          this.componentRef.items = this.items;
          this.componentRef.valueExpr = this.valueExpr;
          this.componentRef.value = this.value;
          this.componentRef.disabled = this.disabled;
          this.componentRef.dataSource = this.dataSource;
          this.componentRef.showClearButton = this.showClearButton;
          this.componentRef.readOnly = this.readOnly;
          this.componentRef.placeholder = this.placeholder;
          this.componentRef.displayExpr = this.displayExpr;
          this.componentRef.stylingMode = this.stylingMode;
          this.componentRef.hoverStateEnabled = this.hoverStateEnabled;
          this.componentRef.height = this.height;
          this.componentRef.width = this.width;
          this.componentRef.visible = this.visible;
          this.componentRef.validationStatus = this.validationStatus;
          this.componentRef.showDropDownButton = this.showDropDownButton;
          this.componentRef.showSelectionControls = this.showSelectionControls;
          this.componentRef.rtlEnabled = this.rtlEnabled ? this.rtlEnabled : false;
          this.componentRef.acceptCustomValue = this.acceptCustomValue;
          this.componentRef.searchEnabled = this.searchEnabled;
          this.componentRef.specificTemplate = this.specificTemplate;
          this.componentRef.searchMode = this.searchMode;
          this.componentRef.searchExpr = this.searchExpr;
          this.componentRef.searchTimeout = this.searchTimeout;
          this.componentRef.class = this.class;
          this.componentRef.valueChange.subscribe((event) => {
            this._value = event;
            this.valueChange.emit(event);
          });
          this.componentRef.onValueChanged.subscribe((event) => {
            this.valueChanged(event);
          });
          this.componentRef.onSelectedItem.subscribe((event) => {
            this.onSelectedItem.emit(event);
          });
          this.componentRef.onCustomItemCreating.subscribe((event) => {
            this.onCustomItemCreating.emit(event);
          });

          this.devExSelectBox = this.componentRef;
        }
      }
      if (this.selectBoxAttributes.id) this.componentRef.id = this.selectBoxAttributes.id;
      if (this.selectBoxAttributes.items) this.componentRef.items = this.selectBoxAttributes.items;
      if (this.selectBoxAttributes.valueExpr) this.componentRef.valueExpr = this.selectBoxAttributes.valueExpr;
      if (this.selectBoxAttributes.value) this.componentRef.value = this.selectBoxAttributes.value;
      if (this.selectBoxAttributes.disabled) this.componentRef.disabled = this.selectBoxAttributes.disabled;
      if (this.selectBoxAttributes.dataSource) this.componentRef.dataSource = this.selectBoxAttributes.dataSource;
      if (this.selectBoxAttributes.showClearButton)
        this.componentRef.showClearButton = this.selectBoxAttributes.showClearButton;
      if (this.selectBoxAttributes.readOnly) this.componentRef.readOnly = this.selectBoxAttributes.readOnly;
      if (this.selectBoxAttributes.placeholder) this.componentRef.placeholder = this.selectBoxAttributes.placeholder;
      if (this.selectBoxAttributes.displayExpr) this.componentRef.displayExpr = this.selectBoxAttributes.displayExpr;
      this.componentRef.stylingMode = this.selectBoxAttributes.stylingMode
        ? this.selectBoxAttributes.stylingMode
        : this.abcComponentService.stylingMode;
      if (this.selectBoxAttributes.hoverStateEnabled)
        this.componentRef.hoverStateEnabled = this.selectBoxAttributes.hoverStateEnabled;
      if (this.selectBoxAttributes.height) this.componentRef.height = this.selectBoxAttributes.height;
      if (this.selectBoxAttributes.width) this.componentRef.width = this.selectBoxAttributes.width;
      if (this.selectBoxAttributes.visible) this.componentRef.visible = this.selectBoxAttributes.visible;
      if (this.selectBoxAttributes.validationStatus)
        this.componentRef.validationStatus = this.selectBoxAttributes.validationStatus;
      if (this.selectBoxAttributes.showDropDownButton)
        this.componentRef.showDropDownButton = this.selectBoxAttributes.showDropDownButton;
      if (this.selectBoxAttributes.showSelectionControls)
        this.componentRef.showSelectionControls = this.selectBoxAttributes.showSelectionControls;
      if (this.selectBoxAttributes.acceptCustomValue)
        this.componentRef.acceptCustomValue = this.selectBoxAttributes.acceptCustomValue;
      if (this.selectBoxAttributes.searchEnabled)
        this.componentRef.searchEnabled = this.selectBoxAttributes.searchEnabled;
      if (this.selectBoxAttributes.specificTemplate)
        this.componentRef.specificTemplate = this.selectBoxAttributes.specificTemplate;
      if (this.selectBoxAttributes.searchMode) this.componentRef.searchMode = this.selectBoxAttributes.searchMode;
      if (this.selectBoxAttributes.searchExpr) this.componentRef.searchExpr = this.selectBoxAttributes.searchExpr;
      if (this.selectBoxAttributes.searchTimeout)
        this.componentRef.searchTimeout = this.selectBoxAttributes.searchTimeout;
      if (this.selectBoxAttributes.class) this.componentRef.class = this.selectBoxAttributes.class;
      observer.next(this.componentRef);
    });
    return observable;
  }

  setCustomDataAttributes(dataAttr: Object) {
    this.componentRef.setCustomDataAttributes(dataAttr);
  }

  setSelectBoxAttributesIfAvailable() {
    this.selectBoxAttributes = {
      id: this.id,
      items: this.items,
      disabled: this.disabled,
      dataSource: this.dataSource,
      placeholder: this.placeholder,
      value: this.value,
      valueExpr: this.valueExpr,
      showClearButton: this.showClearButton,
      readOnly: this.readOnly,
      displayExpr: this.displayExpr,
      stylingMode: this.stylingMode,
      hoverStateEnabled: this.hoverStateEnabled,
      width: this.width,
      height: this.height,
      visible: (this.visible = true),
      validationStatus: this.validationStatus,
      showDropDownButton: (this.showDropDownButton = true),
      showSelectionControls: this.showSelectionControls,
      rtlEnabled: this.rtlEnabled,
      acceptCustomValue: this.acceptCustomValue,
      searchEnabled: this.searchEnabled,
      searchMode: this.searchMode,
      searchExpr: this.searchExpr,
      searchTimeout: this.searchTimeout,
      class: this.class,
    };
  }

  valueChanged(e) {
    this.onValueChanged.emit(e);
  }
  public updateDataSource(dataSource) {
    return this.componentRef.updateDataSource(dataSource);
  }
  public updatePlaceholder(Placeholder) {
    return this.componentRef.updatePlaceholder(Placeholder);
  }
}
